import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { Stack, Typography } from '@mui/material';

import StickyHead from '@/components/StickyHead/StickyHead';
import { HorizontalTab, HorizontalTabs } from '@/components/Tabs';
import { useIsMidotUser } from '@/hooks/permissions/useIsMidotUser';
import { ROUTER_PATHS } from '@/root/linker';

const Users: React.FC = () => {
  const location = useLocation();
  const { t } = useTranslation(['users', 'common']);
  const { isMidotUser } = useIsMidotUser();

  return (
    <Stack>
      <StickyHead sx={{ pt: 2.25 }}>
        <Stack direction="row" mb={isMidotUser ? 3 : 0} alignItems="center" justifyContent="space-between">
          <Typography variant="h2">{t('users.title')}</Typography>
        </Stack>
        {isMidotUser && (
          <HorizontalTabs value={location.pathname}>
            <HorizontalTab
              value={ROUTER_PATHS.USERS_MIDOT}
              label={t('users.tabs.midot')}
              component={Link}
              to={ROUTER_PATHS.USERS_MIDOT}
            />
            <HorizontalTab
              value={ROUTER_PATHS.USERS_CLIENT}
              label={t('users.tabs.client')}
              component={Link}
              to={ROUTER_PATHS.USERS_CLIENT}
            />
          </HorizontalTabs>
        )}
      </StickyHead>
      <Outlet />
    </Stack>
  );
};

export default Users;
